<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="cancelModal"
        persistent
        max-width="530px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ $t('customer.cancelOrderTitle') }}</span></v-flex>
              <v-flex xs1>
                <v-btn
                  flat
                  class="close"
                  @click="emit('close')"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>

            <v-card-text>
              <v-alert
                type="success"
                :value="showAlert"
              >
                {{ $t('adminCancelOrder.orderCanceledSuccessfully') }}
              </v-alert>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('customer.cancelNote')"
                    v-model="form.cancel_note"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="emit('close')"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                style="height:auto" class="rtl-mr-4pct"
                outline
                color="success"
              >{{ $t('common.save') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'

export default {
  props: [
    'cancelModal',
    'id'
  ],

  data() {
    return {
      form: {
        cancel_note: null
      },
      showAlert: false
    }
  },

  methods: {
    submitForm() {
      let token = localStorage.getItem('access_token')
      Axios
        .put(`api/export-order/${this.id}/customer-cancel`, this.form, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(() => {
          this.getResults()
          this.showAlert = true
          setTimeout(() => {
            this.$emit('close')
          }, 1500)
        })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/exportOrder/customerCancelExportOrder.vue